import React from 'react';
import { useFormikContext } from 'formik';
import ReactQuill from 'react-quill';
import { useIntl } from 'react-intl';

interface SectionTwoProps {
  image: string;
  handleImageClick: (img: { url: string; seoUrl: string }) => void;
}

const SectionTwo: React.FC<SectionTwoProps> = ({ image, handleImageClick }) => {
  const formik = useFormikContext<any>();
  const intl = useIntl();

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className='row mt-4'>
        <div className='col-md-12 mb-4'>
          <img
            src={image || formik.values.image}
            alt={formik.values.seoUrl}
            className='border-image h-175px'
            onClick={() =>
              handleImageClick({
                url: image || formik.values.image,
                seoUrl: formik.values.seoUrl,
              })
            }
            style={{ cursor: 'pointer' }}
          />
          <div className='form-group mb-4'>
            <div className='d-flex flex-wrap align-items-center'>
              <div className='col-12 mb-4 me-4'>
                <label className='me-3 mb-3'>
                  <strong>Email :</strong>
                </label>
                <input
                  type='text'
                  className='form-control w-100'
                  name='email'
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.email && formik.errors.email && (
                  <div className='text-danger'>{formik.errors.email as string}</div>
                )}
              </div>

              <div className='col-12 mb-3 me-4'>
                <label className='me-3 mb-3'>
                  <strong>{intl.formatMessage({ id: 'FOOTER.DESCRIPTION' })}</strong>
                </label>
                <ReactQuill
                  value={formik.values.description}
                  onChange={(value) => formik.setFieldValue('description', value)}
                  onBlur={() => formik.setFieldTouched('description', true)}
                  modules={{
                    toolbar: [
                      ['bold', 'italic', 'underline', 'strike'],
                      ['blockquote'],
                      [{ header: 1 }, { header: 2 }],
                      [{ list: 'ordered' }, { list: 'bullet' }],
                      [{ indent: '-1' }, { indent: '+1' }],
                      [{ direction: 'rtl' }],
                      [{ size: ['small', false, 'large', 'huge'] }],
                      [{ header: [1, 2, 3, 4, 5, 6, false] }],
                      [{ font: [] }],
                      ['clean'],
                    ],
                  }}
                  formats={[
                    'header',
                    'font',
                    'size',
                    'bold',
                    'italic',
                    'underline',
                    'strike',
                    'blockquote',
                    'list',
                    'indent',
                    'link',
                    'image',
                    'video',
                  ]}
                />
                {formik.touched.description && formik.errors.description && (
                  <div className='text-danger'>{formik.errors.description as string}</div>
                )}
              </div>
              <div className='col-12 col-md-auto mb-4 me-4'>
                <label className='me-3 mb-3'>
                  <strong>Button :</strong>
                </label>
                <input
                  type='text'
                  className='form-control w-100 w-md-auto'
                  name='Button'
                  value={formik.values.Button}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.Button && formik.errors.Button && (
                  <div className='text-danger'>{formik.errors.Button as string}</div>
                )}
              </div>
            </div>
          </div>
          <div className='modal-footer'>
            <button type='submit' className='btn btn-primary me-2'>
              {intl.formatMessage({ id: 'HEADER.SAVE' })}
            </button>
            <button type='button' className='btn btn-secondary'>
              {intl.formatMessage({ id: 'HEADER.RESET' })}
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default SectionTwo;